/**
 * GRABOT Exhibition Map
 * Lazy-loads Mapbox GL JS and initializes the exhibition map
 */
(function() {
  var mapEl = document.getElementById('exhibition-mapbox');
  if (!mapEl) return;

  var config = window.GrabotExhibitionMap;
  if (!config) return;
  var initialized = false;
  var observerStarted = false;

  function loadMapbox(cb) {
    if (typeof mapboxgl !== 'undefined') return cb();
    var s = document.createElement('script');
    s.src = 'https://api.mapbox.com/mapbox-gl-js/v3.10.0/mapbox-gl.js';
    s.async = true;
    s.onload = cb;
    document.head.appendChild(s);
  }

  function injectCSS() {
    if (document.querySelector('link[href*="mapbox-gl.css"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://api.mapbox.com/mapbox-gl-js/v3.10.0/mapbox-gl.css';
    document.head.appendChild(l);
  }

  function initMap() {
    if (initialized) return;
    initialized = true;
    injectCSS();

    loadMapbox(function() {
    mapboxgl.accessToken = config.token;

    var map = new mapboxgl.Map({
      container: 'exhibition-mapbox',
      style: 'mapbox://styles/mapbox/light-v11',
      projection: 'mercator',
      maxBounds: [[-220, -60], [220, 72]],
      center: [config.lng, config.lat],
      zoom: config.zoom,
      attributionControl: false,
      dragRotate: false,
      touchZoomRotate: true
    });

    map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'bottom-right');

    map.on('load', function() {

      var hideIds = ['road-label', 'road-label-simple', 'transit-label',
        'poi-label', 'airport-label', 'road-number-shield', 'road-shield',
        'transit-shield', 'natural-point-label', 'natural-line-label',
        'water-point-label', 'water-line-label', 'aeroway-line',
        'aeroway-polygon', 'structure-label', 'building-label',
        'building-outline', 'building', 'road-motorway-link',
        'road-trunk-link', 'road-primary-link', 'road-secondary-link',
        'road-tertiary-link', 'road-street-link', 'road-street_limited-link',
        'road-minor-link', 'road-service-link', 'road-alley-link',
        'road-pedestrian-link', 'road-rail-link', 'ferry',
        'road-path', 'road-steps', 'road-major-link',
        'road-motorway', 'road-trunk', 'road-primary',
        'road-secondary', 'road-tertiary', 'road-street',
        'road-street_limited', 'road-minor', 'road-service',
        'road-alley', 'road-pedestrian', 'road-rail'];
      hideIds.forEach(function(id) {
        if (map.getLayer(id)) map.setLayoutProperty(id, 'visibility', 'none');
      });

      map.setPaintProperty('background', 'background-color', '#dce6f2');

      if (map.getLayer('water')) {
        map.setPaintProperty('water', 'fill-color', '#8fb8d8');
      }

      ['landuse', 'landuse-residential', 'landuse-commercial', 'landuse-industrial',
       'landuse-school', 'landuse-hospital', 'landuse-park', 'landuse-cemetery',
       'landuse-pitch', 'landuse-sand'].forEach(function(id) {
        if (map.getLayer(id)) map.setPaintProperty(id, 'fill-color', '#e2ecf6');
      });

      ['national-park', 'park', 'landcover', 'landcover-wood', 'landcover-grass',
       'landcover-ice', 'landcover-sand', 'landcover-snow'].forEach(function(id) {
        if (map.getLayer(id)) map.setPaintProperty(id, 'fill-color', '#d8e8f4');
      });

      if (map.getLayer('country-label')) {
        map.setPaintProperty('country-label', 'text-color', '#3d4f6b');
        map.setPaintProperty('country-label', 'text-halo-color', '#e8f0f8');
        map.setPaintProperty('country-label', 'text-halo-width', 2);
      }

      ['settlement-label', 'settlement-subdivision-label'].forEach(function(id) {
        if (map.getLayer(id)) {
          map.setPaintProperty(id, 'text-color', '#5a6d85');
          map.setPaintProperty(id, 'text-halo-color', '#e8f0f8');
          map.setPaintProperty(id, 'text-halo-width', 1.5);
        }
      });

      var canvas = document.createElement('canvas');
      canvas.width = 8; canvas.height = 8;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = 'rgba(8,101,254,0.25)';
      ctx.beginPath();
      ctx.arc(4, 4, 1.5, 0, Math.PI * 2);
      ctx.fill();
      map.addImage('dot-pattern', { width: 8, height: 8, data: new Uint8Array(ctx.getImageData(0, 0, 8, 8).data.buffer) });

      if (map.getLayer('land-structure-polygon')) {
        map.setPaintProperty('land-structure-polygon', 'fill-pattern', 'dot-pattern');
        map.setPaintProperty('land-structure-polygon', 'fill-opacity', 0.6);
      }

      // ---- Markers ----
      var allCardEls = document.querySelectorAll('.ex-card');

      (config.markers || []).forEach(function(m) {
        var el = document.createElement('div');
        el.className = 'ex-mapbox-marker';
        el.innerHTML = '<span class="ex-mapbox-dot"></span>';
        el.title = m.country;

        var popup = new mapboxgl.Popup({
          offset: 24,
          closeButton: false,
          className: 'ex-mapbox-popup'

        }).setHTML('<div class="ex-popup"><div class="ex-popup-country">' + m.country + '</div></div>');

        var marker = new mapboxgl.Marker({ element: el, anchor: 'center' })
          .setLngLat([m.lng, m.lat])
          .setPopup(popup)
          .addTo(map);

        el.addEventListener('click', function() {
          var matchCards = [];
          allCardEls.forEach(function(c) {
            var cLat = parseFloat(c.getAttribute('data-map-lat') || '0');
            var cLng = parseFloat(c.getAttribute('data-map-lng') || '0');
            if (Math.abs(cLat - m.lat) < 0.5 && Math.abs(cLng - m.lng) < 0.5) {
              matchCards.push(c);
            }
          });
          allCardEls.forEach(function(c) { c.classList.remove('ex-card-active'); });
          matchCards.forEach(function(c) { c.classList.add('ex-card-active'); });
          if (matchCards.length) {
            matchCards[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      });

      // ---- Card -> Map flyTo ----
      allCardEls.forEach(function(card) {
        card.addEventListener('click', function() {
          var lat = parseFloat(card.getAttribute('data-map-lat') || '0');
          var lng = parseFloat(card.getAttribute('data-map-lng') || '0');
          if (lat && lng) {
            map.flyTo({ center: [lng, lat], zoom: 6, duration: 1200 });
          }
        });
      });

    });
  });
  }

  function startMapObserver() {
    if (observerStarted) return;
    observerStarted = true;

    if (!('IntersectionObserver' in window)) {
      window.setTimeout(initMap, 1200);
      return;
    }

    var mapObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          mapObserver.disconnect();
          initMap();
        }
      });
    }, { rootMargin: '150px 0px', threshold: 0 });
    mapObserver.observe(mapEl);
  }

  window.addEventListener('scroll', startMapObserver, { once: true, passive: true });
  window.addEventListener('touchstart', startMapObserver, { once: true, passive: true });
  window.setTimeout(startMapObserver, 8000);

})();
